new MutationObserver(() => {
  document.querySelectorAll('#upCart').forEach(el => {
    el.setAttribute('role', 'region')
    el.setAttribute('aria-label', 'upcart')
  });
  document.querySelectorAll('img').forEach(el => {
    if (!el.hasAttribute('alt')) {
        el.setAttribute('alt', '')
    }
  });
}).observe(document.body, { childList: true, subtree: true });

document.querySelectorAll('#upCart').forEach(el => {
    el.setAttribute('role', 'region')
    el.setAttribute('aria-label', 'upcart')
  });
document.querySelectorAll('img').forEach(el => {
    if (!el.hasAttribute('alt')) {
        el.setAttribute('alt', '')
    }
  });